import Vue from 'Vue';

/**
 * ********************************************************************
 * standard import lines for every component. Importing the template
 * and the component specific style.
 * ********************************************************************
 */
import './dc-category-filter.style.scss';
import template from './dc-category-filter.template.htm';
/**
 * *********************************************************************
 */

export default Vue.component('dc-category-filter', {
    template: template,
    props: ['item'],
    data() {
        return {
            active:false
        };
    },
    computed: {
        activeCategories(){
            return this.$store.getters.filters.categories;
        },
        isActive(){
            let mainCategoryActive = this.isCategoryActive(this.item);
            let subCategoriesActive = _.some(this.item.subcategories, subcategory => this.isCategoryActive(subcategory));
            return mainCategoryActive || subCategoriesActive;
        }
    },
    created() {},
    mounted() {
        console.log(this.item.icon);
    },
    methods: {
        getName(subcategoryName){
            if(Array.isArray(subcategoryName)){
                if(!!subcategoryName[0] && !!subcategoryName[0]["@value"])
                    return subcategoryName[0]["@value"];
                return subcategoryName[0];
            }
            else {
                if (!!subcategoryName && !!subcategoryName["@value"])
                    return subcategoryName["@value"];
                return subcategoryName;
            }
        },
        isCategoryActive(subcategory){
            return _.find(this.activeCategories,activeCategory => activeCategory.id == subcategory.id) !== undefined;
        },
        toggleCategory(subcategory){
            if(this.isCategoryActive(subcategory))
                this.$store.commit('removeActiveCategory', subcategory);
            else
                this.$store.commit('addActiveCategory', subcategory);
        }
    },
    watch: {}
});